import React, { useState } from "react"
import "./index.scss"

const AlertNotification = ({ type, text, show }) => {
  const [open, setOpen] = useState(true)

  return (
    <div className={open && show ? "alert-notification" : "alert-hide"}>
      <div className="alert-wrapper">
        <p className="text">{text}</p>
        <button
          className="close-button"
          onClick={() => {
            setOpen(!open)
          }}
        >
          Close
        </button>
      </div>
    </div>
  )
}

export default AlertNotification
